<template>
    <div class="a-control">
        <label
            class="a-label a-control__label"
            :for="id"
            v-if="label && type !== 'checkbox'"
        >{{ label }}</label>
        <textarea
            v-if="type === 'textarea'"
            class="a-control__input"
            :name="name"
            :id="id"
            :rows="rows"
            :cols="cols"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            :value="value"
            :required="required"
            :disabled="disabled"
        ></textarea>
        <label
            v-else-if="type === 'checkbox'"
            class="a-control__checkbox"
            :for="id"
        >
            <div
                class="a-control__checkboxLabel"
            >
                <slot v-if="$slots.default"></slot>
                <p v-else>{{ label }}</p>
            </div>
            <input
                :checked="value"
                :id="id"
                :name="name"
                type="checkbox"
                class="a-control__checkboxInput"
                @input="$emit('input', $event.target.value )"
                :value="value"
                :required="required"
                :disabled="disabled"
            />
            <span class="a-control__checkboxCheckmark"></span>
        </label>
        <label
            v-else-if="type === 'radio'"
            class="a-control__radio"
            :for="id"
        >
            <div
                class="a-control__radioLabel"
            >
                <slot v-if="$slots.default"></slot>
                <p v-else>{{ label }}</p>
            </div>
            <input
                :id="id"
                :name="name"
                type="radio"
                class="a-control__radioInput"
                @input="$emit('input', $event.target.value)"
                :value="value"
                :required="required"
                :disabled="disabled"
            />
            <div class="a-control__radioBorder"></div>
            <span class="a-control__radioCheckmark"></span>
        </label>
        <input
            v-else-if="type === 'number'"
            :name="name"
            :type="type"
            :id="id"
            class="a-control__input"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            :value="value"
            :required="required"
            :disabled="disabled"
            :min="min ? min : false"
            :max="max ? max : false"
        />
        <input
            v-else-if="type === 'mask'"
            :name="name"
            :type="type"
            :id="id"
            class="a-control__input"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            :value="value"
            :required="required"
            :disabled="disabled"
            v-mask="mask"
            :tokens="tokens"
        />
        <input
            v-else
            :name="name"
            :type="type"
            :id="id"
            class="a-control__input"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
            :value="value"
            :required="required"
            :disabled="disabled"
            :maxlength="maxlength ? maxlength : false"
            :autocomplete="autocomplete"
        />
        <o-notifications
            :is-static="true"
            :name="id"
        />
    </div>
</template>

<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Boolean],
            default: ''
        },
        checked: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        rows: {
            default: 8
        },
        cols: {
            default: 80
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        min: {
            type: [Number, String],
            required: false
        },
        max: {
            type: [Number, String],
            required: false
        },
        maxlength: {
            type: [Number, String],
            required: false
        },
        mask: {
            type: String,
            default: ''
        },
        autocomplete: {
            type: String,
            default: ''
        },
        tokens: {
            type: Object,
            default: () => {}
        }
    }
}
</script>
